/* mo:mo Header — Mobile-Flyout: Öffnen/Schließen (Burger, X, Backdrop, Escape) */
(function () {
  function init(header) {
    var toggle = header.querySelector('[data-momo-menu-toggle]');
    var menu = header.querySelector('[data-momo-menu]');
    var backdrop = header.querySelector('[data-momo-menu-backdrop]');
    var closeBtn = header.querySelector('[data-momo-menu-close]');
    if (!toggle || !menu) return;

    function isOpen() { return header.classList.contains('momo-header--menu-open'); }
    function open() {
      header.classList.add('momo-header--menu-open');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      var first = menu.querySelector('a, button');
      if (first) first.focus();
    }
    function close() {
      header.classList.remove('momo-header--menu-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      toggle.focus();
    }

    toggle.addEventListener('click', function () { isOpen() ? close() : open(); });
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (backdrop) backdrop.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) close();
    });
  }
  document.querySelectorAll('.momo-header').forEach(init);
})();
